import React from 'react';
import {Link} from 'react-router-dom';
import {infoType, OneNewsTypes} from '../../../types/TypesNews';
import {useTranslation} from 'react-i18next';

type Props = {
	msg: OneNewsTypes;
	currentCategory: number | null;
	currentTag: number | null;
	handleChangeListItem: (id: number, type: string, catName?: string) => void;
};

const NewsListElement: React.FC<Props> = ({
	msg,
	currentCategory,
	currentTag,
	handleChangeListItem,
}) => {
	const {t} = useTranslation();
	return (
		<div className="media-slider__item">
			<div className="media-slider__date">{msg.published_date}</div>
			<Link
				to={`/news/${msg.id}`}
				className="media-slider__title"
				style={{textDecoration: 'none', cursor: 'pointer', display: 'block'}}
			>
				{msg.topic}
			</Link>
			<Link
				to={`/news/${msg.id}`}
				className="media-slider__text"
				style={{textDecoration: 'none', cursor: 'pointer', display: 'block'}}
				dangerouslySetInnerHTML={{__html: msg.small_text}}
			/>
			<Link
				to={`/news/${msg.id}`}
				id="mainSliderButton"
				className="media-slider__button"
			>
				{t('Подробиці')}
			</Link>
			<div className="media-slider__category">
				{JSON.parse(msg.category).map(
					(c: infoType) =>
						c.name !== null && (
							<button
								key={c.id}
								className={'media-slider__categoryButton'}
								type="button"
								onClick={() => handleChangeListItem(c.id, 'category', c.name)}
								style={currentCategory === c.id ? {fontWeight: 700} : undefined}
							>
								{'  ' + `#${c.name}`}
							</button>
						),
				)}
			</div>
			<div className="media-slider__tag">
				{JSON.parse(msg.tags).map(
					(t: infoType) =>
						t.name !== null && (
							<button
								key={t.id}
								className={'media-slider__categoryButton'}
								type="button"
								onClick={() => handleChangeListItem(t.id, 'tag', t.name)}
								style={currentTag === t.id ? {fontWeight: 700} : undefined}
							>
								{'  ' + `#${t.name}`}
							</button>
						),
				)}
			</div>
			{/*<div className="media-slider__views">
				Переглянуто: {msg.count_viewed}
			</div>*/}
		</div>
	);
};

export default NewsListElement;
